"use client"

import VideoModal from "@/(admin)/modules/ui-builder/config/components/VideoModal";
import { extractTwitterId } from "@/(admin)/modules/ui-builder/config/lib/twitter-helpers";
import { extractYouTubeId, getYouTubeThumbnail } from "@/(admin)/modules/ui-builder/config/lib/youtube-helpers";
import { Images } from "@/constants/images";
import Image from "next/image";
import { useState } from "react";

type PromoVideosSectionProps = {
    promoVideoUrls?: string[]
}

export default function PromoVideosSection({ promoVideoUrls = [] }: PromoVideosSectionProps) {
    const [modalVideo, setModalVideo] = useState<string>("")
    const [isModalOpen, setIsModalOpen] = useState(false)

    if (!promoVideoUrls || promoVideoUrls.length === 0) {
        return null
    }

    const openModal = (youtubeUrl: string) => {
        setModalVideo(youtubeUrl)
        setIsModalOpen(true)
    }

    const closeModal = () => {
        setIsModalOpen(false)
        setModalVideo("")
    }

    const renderPromoVideoCard = (videoUrl: string, index: number) => {
        const ytId = extractYouTubeId(videoUrl)
        const twId = extractTwitterId(videoUrl)

        const thumb = ytId ? getYouTubeThumbnail(ytId, "hqdefault") : null

        return (
            <div
                key={`promo-video-${index}`}
                className="flex flex-col cursor-pointer group"
                onClick={() => openModal(videoUrl)}
            >
                <div className="relative w-full group">
                    <div className="w-full sm:h-[182px] h-[257px] overflow-hidden z-[1] relative">
                        {thumb ? (
                            <Image
                                src={thumb}
                                alt={`Promo video ${index + 1}`}
                                fill
                                className="object-cover group-hover:scale-110 transition-all duration-300"
                                sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                            />
                        ) : (

                            <div className="w-full h-full bg-black flex flex-col items-center justify-center gap-2">
                                <svg viewBox="0 0 24 24" className="w-12 h-12 fill-white"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 22.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.008 5.965H5.078z" /></svg>
                                <span className="text-white/50 text-[10px] font-bold tracking-tighter">VIEW POST</span>
                            </div>
                        )}
                    </div>
                    {/* Play button overlay */}
                    <div className="absolute inset-0 flex items-center justify-center z-[2]">
                        <div className="w-[60px] h-[60px] relative">
                            <Image src={Images.playIconWhite} alt="play" fill className="object-cover" sizes="60px" />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            {promoVideoUrls.length > 0 && (
                <>
                    <div className="flex flex-col gap-3 mt-5">
                        <h3 className="text-sm font-semibold text-[#333] uppercase tracking-wide">
                            Video quảng cáo
                        </h3>

                        <div className="grid grid-cols-1 gap-3 sm:gap-4">
                            {promoVideoUrls.map((videoUrl, index) =>
                                renderPromoVideoCard(videoUrl, index)
                            )}
                        </div>
                    </div>

                    <VideoModal isOpen={isModalOpen} videoUrl={modalVideo} onClose={() => setIsModalOpen(false)} />
                </>
            )}
        </>
    )
}